var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-book-bookmark.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 2.51001H6C4.794 2.51001 3 3.30901 3 5.51001V19.51C3 21.711 4.794 22.51 6 22.51H21V20.51H6.012C5.55 20.498 5 20.315 5 19.51C5 19.409 5.009 19.319 5.024 19.237C5.136 18.662 5.607 18.52 6.011 18.51H20C20.018 18.51 20.031 18.501 20.049 18.5H21V4.51001C21 3.40701 20.103 2.51001 19 2.51001ZM19 16.51H5V5.51001C5 4.70401 5.55 4.52201 6 4.51001H13V11.51L15 10.51L17 11.51V4.51001H19V16.51Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a0f88370d8cfb3dcdc8ba810b282e421.svg";
export { ForwardRef as ReactComponent };